import moment from 'moment';

const mentIllScale = {
  'Not assessed': 0,
  Normal: 1,
  'Borderline mentally ill': 2,
  'Mildly ill': 3,
  'Moderately ill': 4,
  'Markedly ill': 5,
  'Severely ill': 6,
  'Among the most extremely ill': 7,
};

export const DataMapperInsightArchiveTable = (data) => {
  let allData = [];

  if (data) {
    for (let i = 0; i < data.length; i++) {
      let insight = [];

      insight.id = data[i].id;

      let actionLength = data[i].action_log.length;

      insight.insightDateRisk =
        moment(data[i].when_created).format('DD MMM YYYY') +
        ' - ' +
        (data[i].risk_status === 'h'
          ? 'High'
          : data[i].risk_status === 'm'
            ? 'Moderate'
            : data[i].risk_status === 'l'
              ? 'Low'
              : 'no data');

      insight.status =
        data[i].action_status === 'E' ||
        data[i].action_status === 'A' ||
        data[i].action_status === 'D' ||
        data[i].action_status === 'C' ||
        data[i].action_status === 'S'
          ? 'Closed'
          : data[i].action_status === null
            ? 'Review in progress'
            : data[i].action_status === 'I'
              ? 'Ignored'
              : 'no data';

      insight.insightDescription = data[i].why_created;
      insight.followUpNotes = data[i].action_log;
      insight.scale =
        actionLength > 0 && data[i].action_status !== 'I'
          ? mentIllScale[
              data[i].action_log[actionLength - 1].current_mental_illness
            ]
          : '-';
      insight.support =
        actionLength > 0 && data[i].action_status !== 'I'
          ? data[i].action_log[actionLength - 1].subsequent_support
          : '-';
      insight.addAction = true;
      // TODO - add view insight
      //insight.view = true;
      insight.export = false;

      allData.push(insight);
    }
  }

  return allData;
};
